import { IconProps } from './types';
import { useId } from 'react';

export default function IconChevron({ width = '24', height = '27', stroke = '#7F0016', stopColor = '#F3A9B6', className }: IconProps) {
    const gradientId = `${useId().replace(/:/g, '')}-chevron-gradient`

    return (
        <svg width={width} height={height} viewBox='0 0 24 27' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
            <path d='M15.6953 1.6958L4.56738 12.8521L4.21582 13.2056L4.56738 13.5591L15.6953 24.7153L16.3652 25.3862L16.541 24.4546L17.6006 18.8228L17.6572 18.521L17.4141 18.3335L10.7246 13.2056L17.4141 8.07764L17.6572 7.89014L17.6006 7.58838L16.541 1.95654L16.3652 1.0249L15.6953 1.6958Z' fill={`url(#${gradientId})`} stroke={stroke} />
            <defs>
                <linearGradient id={gradientId} x1='11.0156' y1='2.04932' x2='11.0156' y2='24.3618' gradientUnits='userSpaceOnUse'>
                    <stop stopColor={stopColor} />
                    <stop offset='1' stopColor='white' />
                </linearGradient>
            </defs>
        </svg>

    )
}
